// Shared display mapping for the check_kind classification (fisico vs echeq).
// Single source of truth so labels never drift between forms, listings, and badges.

export const CHECK_KIND_LABELS = {
  fisico: 'Físico',
  echeq: 'eCheq',
};

export const CHECK_KIND_OPTIONS = [
  { value: 'fisico', text: 'Físico' },
  { value: 'echeq', text: 'eCheq' },
];
